import { useQuery } from "@tanstack/react-query";
import { Modal, Table } from "antd";
import moment from "moment/moment";
import React, { useState } from "react";
import {
  getAssignClientList,
  getProjectWiseUploadedList,
} from "../../../../api/apiCallManager";
import { API_CONSTANTS } from "../../../../api/Constants";
import useClientInfoList from "../../../../components/hooks/useClientInfoList";
import AccessTo from "../../../../components/is-show/AccessTo";
import { SM } from "../../../router/AddRoutesJson";
import UploadDataForm from "./UploadDataForm";
import { LuFileEdit } from "react-icons/lu";
import { AiTwotoneFileAdd } from "react-icons/ai";
import { BsFileEarmarkArrowUp } from "react-icons/bs";
import useProjectSpecificFilesList from "../../../../components/hooks/useProjectSpecificFilesList";
import { MdBlock } from "react-icons/md";

// Fetch data from the API

const ProjectSpecificUploadedList = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEditData, setSelectedEditData] = useState(null);

  const { data, error, isLoading } = useProjectSpecificFilesList();

  const showModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Columns definition
  const columns = [
    {
      title: "Dataset Name",
      dataIndex: "dataSetName", // Assuming this field exists
      key: "dataSetName",
    },

    // {
    //   title: "S3 Path",
    //   dataIndex: "bucketPath", // Assuming this corresponds to the S3 path
    //   key: "bucketPath",
    //   render: (bucketPath) => (
    //     <a href={bucketPath}>
    //       <LiaFileDownloadSolid size={18} />
    //     </a>
    //   ),
    // },
    // {
    //   title: "Project Name",
    //   dataIndex: "projectKey",
    //   key: "projectKey",
    // },
    // {
    //   title: "Project Description",
    //   dataIndex: "projectDescription", // Assuming this field exists
    //   key: "projectDescription",
    // },
    {
      title: "Region",
      dataIndex: "region", // Assuming this field exists
      key: "region",
    },
    // {
    //   title: "Description",
    //   dataIndex: "description", // Assuming this field exists
    //   key: "description",
    // },
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
    },
    {
      title: "Site Name",
      dataIndex: "siteName", // Assuming this field exists
      key: "siteName",
    },
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "fileName",
    },

    {
      title: "Timestamp",
      dataIndex: "uploadTime",
      key: "uploadTime",
      render: (time) => moment(time).format("MMMM DD, YYYY"),
    },
    {
      title: "Action",
      dataIndex: "-",
      key: "ac",
      render: (_, data) => (
        <>
          {data.status == "locked" ? (
            <MdBlock color="red" size={"19"} />
          ) : (
            <BsFileEarmarkArrowUp
              className=" cursor-pointer"
              color="green"
              size={"19"}
              onClick={() => {
                showModal();
                setSelectedEditData(data);
              }}
            />
          )}
        </>
      ),
    },
  ];

  return (
    <div className="px-4 pb-4">
      {/* {JSON.stringify(data)}========= */}
      <Modal
        destroyOnClose={true}
        title=""
        open={isModalOpen}
        onCancel={closeModal}
        maskClosable={false}
        footer={null}
      >
        <UploadDataForm
          closeModal={closeModal}
          selectedEditData={selectedEditData}
        />
      </Modal>
      <div className="my-4"></div>
      <AccessTo role={[SM]}>
        <div className="flex justify-end items-center mb-3">
          <button
            className="crt-usr-btn"
            onClick={() => {
              showModal();
              setSelectedEditData(null);
            }}
            disabled={isLoading || data?.length}
          >
            + Upload
          </button>
        </div>
      </AccessTo>
      <Table
        scroll={{ x: 600 }}
        dataSource={data}
        columns={columns}
        className="user-table-theme"
        rowKey="record_id" // Use unique identifier
      />
    </div>
  );
};

export default ProjectSpecificUploadedList;
